import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  HStack,
  Stack,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { InvoiceTypeEnum, useInvoiceStore } from "../../store";
import { CreateOutgoingButton } from "./CreateOutgoingButton";
import { CreateProformaButton } from "./CreateProformaButton";
import { SaveAsDraftButton } from "./SaveAsDraftButton";

export const FooterNav = observer(function FooterNav() {
  const store = useInvoiceStore();
  const { workspaceStore } = useStore();

  return (
    <Stack mt="6" spacing="3">
      {!store.hasNextStep && store.form.form.hasError && (
        <Alert rounded="lg" status="error">
          <AlertIcon />
          <AlertDescription>
            <Trans>Oops! It seems there are errors in the form.</Trans>&nbsp;
            {workspaceStore.settings?.can_skip_invoice_date_validations &&
              store.dateErrorsOnly && (
                <Trans>But it is still possible to proceed and save.</Trans>
              )}
          </AlertDescription>
        </Alert>
      )}
      <HStack
        justify="space-between"
        w="full"
        mt="6"
        spacing={{
          base: "2",
          md: "unset",
        }}
      >
        <div>
          {!!store.hasPrevStep && (
            <Button
              px={{
                base: "2",
                md: "4",
              }}
              colorScheme="grey"
              onClick={store.goToPrevStep}
              variant="outline"
            >
              <Trans>Previous step</Trans>
            </Button>
          )}
        </div>
        <HStack
          justify="end"
          spacing={{
            base: "2",
            md: "3",
          }}
        >
          {store.isRFI && <SaveAsDraftButton />}
          {store.hasNextStep ? (
            <Button
              px={{
                base: "2",
                md: "4",
              }}
              onClick={store.goToNextStep}
            >
              <Trans>Next step</Trans>
            </Button>
          ) : store.type === InvoiceTypeEnum.Proforma ? (
            <CreateProformaButton />
          ) : (
            <CreateOutgoingButton />
          )}
        </HStack>
      </HStack>
    </Stack>
  );
});
